module.exports = __webpack_public_path__ + "static/img/login_column_two01.b7f22b1c.png";